<div class="delivery-option" *ngIf="deliveryOptions.length !== 0">
    <ul>
      <li *ngFor="let deliveryOption of deliveryOptions; let i = index">
        <input #cbs id="lidl-lib-delivery-fe-{{deliveryOption.key}}" type="radio" name="payment-option"
     [checked]="isSelected(i)" (change)="emitSelectedRadioButton(i)" ngModel />
        <label for="lidl-lib-delivery-fe-{{deliveryOption.key}}">
          <p class="option-title">
            {{ deliveryOption.name }}
          </p>
          <p class="option-desc">
            {{ deliveryOption.description }}
          </p>
        </label>
        <span class="delivery-option">{{ deliveryOption.currency }} {{ deliveryOption.price | number: '1.2'}}</span>
      </li>
    </ul>

    <!-- To Display error in case delivery option returns an error -->
    <!-- <div class="col-lg-12 alert alert-danger text-center" role="alert" *ngIf="error$| async">
      Error !
    </div> -->
  </div>
